<template>
    <div>
        <div class="container">
            <div class="handle-box">
                <el-select v-model="platform_type" class="handle-select mr10" @change="selectHandle">
                    <el-option
                      v-for="(child, index) in platform_types"
                      :key="index"
                      :label="child.name" :value="child.id"></el-option>
                </el-select>
                <el-select v-model="read_id" class="handle-select mr10" @change="selectHandle">
                    <el-option
                      v-for="(child, index) in reads"
                      :key="index"
                      :label="child.name" :value="child.id"></el-option>
                </el-select>
                <el-input v-model="keyword" placeholder="请输入手机号" class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                v-loading="loading"
            >
                <el-table-column label="序号" align="center" width="50">
                    <template slot-scope="scope">
                        <span>{{scope.$index+1+page_index}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="客户端" align="center">
                    <template slot-scope="scope">
                        {{getPlatformName(scope.row.platform_type)}}
                    </template>
                </el-table-column>
                <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
                <el-table-column prop="content" label="内容" align="center"></el-table-column>
                <el-table-column label="状态" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.is_read">已读</span>
                        <span v-else>未读</span>
                    </template>
                </el-table-column>
                <el-table-column label="日期" align="center">
                    <template slot-scope="scope">
                        {{formatDate(scope.row.created_at)}}
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="160" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            v-if="!scope.row.is_read"
                            @click="handleIsReader(scope.row)"
                        >设置已读</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            @click="handleDelete(scope.row)"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination" v-if="totalPages > 1">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :current-page="currentPage"
                    :page-size="page_size"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog title="编辑" :visible.sync="editVisible" width="30%" :close-on-click-modal="false">
            <el-form ref="form" :model="form" label-width="70px">
                <el-form-item label="用户名">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="地址">
                    <el-input v-model="form.address"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {_} from 'vue-underscore';
import http from '../../../api/hemeraApiConfig'
export default {
    name: 'Feedbackmanage',
    data() {
        return {
            platform_types: [
                {'name': '全部', 'id': 0},
                {'name': '患者端', 'id': 1},
                {'name': '医生端', 'id': 2}
            ],
            platform_type: 0,
            reads:[
                {'name': '全部', 'id': ''},
                {'name': '未读', 'id': '0'},
                {'name': '已读', 'id': '1'}
            ],
            read_id: '',
            tableData: [],
            currentPage: 1,
            totalPages: 1,
            page_size: 10,
            pageTotal: 10,
            page_index: 10,
            keyword: '',
            loading: false,
            multipleSelection: [],
            delList: [],
            editVisible: false,
            form: {}
        };
    },
    created() {
        this.getData();
    },
    methods: {
        formatDate(time){
            return new Date(time*1000).Format('YYYY-MM-DD hh:mm:ss');
        },
        getPlatformName(id){
            var item = _.filter(this.platform_types, function(selector){ return selector.id == id; })[0];
            if(item){
                return item['name'];
            }else{
                return '';
            }
        },
        getData() {
            let that = this;
            that.loading = true;
            let params = {
                page: that.currentPage,
                page_size: that.page_size
            }
            if(that.keyword){
                params["phone"] = that.keyword;
            }
            if(that.read_id){
                params["is_read"] = that.read_id;
            }
            params['platform_type'] = that.platform_type;
            http.get("suggestions",{params: params}).then(function(res) {
                that.page_index = (that.currentPage - 1) * that.page_size;
                that.tableData = res.data.data.suggestions;
                that.currentPage = res.data.data.page;
                that.totalPages = res.data.data.total_pages;
                that.pageTotal = that.totalPages * that.page_size;
                that.loading = false;
            });
        },
        selectHandle(){
            this.currentPage = 1;
            this.getData();
        },
        handleSearch() {
            this.currentPage = 1;
            this.getData();
        },
        handleIsReader(row) {
            let that = this;
            that.$confirm('确定要设置已读吗？', '提示', {
                type: 'warning'
            })
            .then(() => {
                http.put("suggestions/"+row.id).then(function(res) {
                    // console.log(res);
                    if (res.data.status_code == 200) {
                        that.$message.success('设置成功');
                        that.getData();
                    }
                });
            })
            .catch(() => {});
        },
        handleDelete(row) {
            let that = this;
            // 二次确认删除
            that.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
            .then(() => {
                http.delete("suggestions/"+row.id).then(function(res) {
                    // console.log(res);
                    if (res.data.status_code == 200) {
                        that.$message.success('删除成功');
                        that.getData();
                    }
                });
            })
            .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
            let str = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                str += this.multipleSelection[i].name + ' ';
            }
            this.$message.error(`删除了${str}`);
            this.multipleSelection = [];
        },
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
            this.form = row;
            this.editVisible = true;
        },
        // 保存编辑
        saveEdit() {
            this.editVisible = false;
            this.$message.success(`修改第 ${this.idx + 1} 行成功`);
            this.$set(this.tableData, this.idx, this.form);
        },
        // 分页导航
        handlePageChange(val) {
            this.currentPage = val;
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
